module.exports = __webpack_public_path__ + "img/mono_14.01532f09.png";